import HomePage from '~psp-pages/brussels/home/home.vue'
import Payment from '~psp-pages/brussels/redemption/payment.vue'
import Summary from '~psp-pages/brussels/redemption/summary.vue'
import RedemptionPage from '~psp-pages/brussels/redemption/redemption.vue'

import routerBuilder from './routerBuilder'

const router = routerBuilder({
  HomePage, RedemptionPage, Summary, Payment,
})

export default router
